import type { PrintSettings } from "@nevisign/reader-core";

type Props = {
  settings: PrintSettings;
  onChange: (partial: Partial<PrintSettings>) => void;
  onPrint: () => void;
  onClose: () => void;
  busy?: boolean;
};

export function PrintSheet({
  settings,
  onChange,
  onPrint,
  onClose,
  busy,
}: Props) {
  return (
    <div className="print-sheet" role="dialog" aria-label="چاپ و خروجی PDF">
      <div className="print-sheet-header">
        <strong>چاپ / خروجی PDF</strong>
        <button type="button" className="icon-btn compact" onClick={onClose}>
          بستن
        </button>
      </div>
      <div className="print-sheet-body">
        <div className="settings-field">
          <label htmlFor="print-size">اندازه صفحه</label>
          <select
            id="print-size"
            value={settings.pageSize}
            onChange={(e) =>
              onChange({ pageSize: e.target.value as PrintSettings["pageSize"] })
            }
          >
            <option value="A4">A4</option>
            <option value="Letter">Letter</option>
          </select>
        </div>
        <div className="settings-field">
          <label htmlFor="print-orient">جهت</label>
          <select
            id="print-orient"
            value={settings.orientation}
            onChange={(e) =>
              onChange({
                orientation: e.target.value as PrintSettings["orientation"],
              })
            }
          >
            <option value="portrait">عمودی</option>
            <option value="landscape">افقی</option>
          </select>
        </div>
        <div className="settings-field">
          <label htmlFor="print-margin">حاشیه (میلی‌متر)</label>
          <input
            id="print-margin"
            type="number"
            min={0}
            max={40}
            value={settings.marginMm}
            onChange={(e) =>
              onChange({ marginMm: Math.max(0, Number(e.target.value) || 0) })
            }
          />
        </div>
        <div className="settings-field">
          <label htmlFor="print-color">رنگ</label>
          <select
            id="print-color"
            value={settings.colorMode}
            onChange={(e) =>
              onChange({
                colorMode: e.target.value as PrintSettings["colorMode"],
              })
            }
          >
            <option value="color">رنگی</option>
            <option value="grayscale">سیاه‌وسفید</option>
          </select>
        </div>
        <div className="settings-field">
          <label>
            <input
              type="checkbox"
              checked={settings.includeComments}
              onChange={(e) => onChange({ includeComments: e.target.checked })}
            />{" "}
            نمایش یادداشت‌ها در چاپ (Word)
          </label>
        </div>
        <p className="settings-hint">
          برای ابزار «تبدیل Word به PDF» کافی است بعد از باز شدن دیالوگ چاپ،
          گزینهٔ «Save as PDF» را انتخاب کنید.
        </p>
      </div>
      <div className="print-sheet-actions">
        <button
          type="button"
          className="icon-btn primary"
          disabled={busy}
          onClick={onPrint}
        >
          {busy ? "در حال آماده‌سازی…" : "ادامه"}
        </button>
      </div>
    </div>
  );
}
